// jQuery must be on window.$ BEFORE any jQuery plugins load.
// ES modules execute imports in dependency order, so this runs first.
import './vendor-jquery-setup.js';

import DirectorRouter from './vendor/director-custom-query-skip.min.js';

// jQuery plugins — these access window.$ internally
import './vendor/jquery.dotdotdot.min.js';
import './vendor/jquery.autosize.min.js';

// Vendor utilities
import './vendor/focusable-shim.js';
import './vendor/ellipsis.js';

// Remaining globals
window.DirectorRouter = DirectorRouter.Router || DirectorRouter;
